import { createContext } from "react";

import { User } from "@/types";

type UserContext = { user?: User };

export const UserContext = createContext<UserContext>({});
